<!--
   Created by qing on 2020/12/18
   Des: 
-->
<template>
  <div class="mix-form-list-page" v-wechat-title="title">
    <van-search v-model="filterInfo.keyWords"  @search="onSearch" placeholder="请输入搜索关键词" />
    <van-dropdown-menu active-color="#4A66FA">
      <van-dropdown-item v-model="tempListType" :options="listTypeOpt" @change="listTypeChange" />
      <van-dropdown-item v-model="filterInfo.archived" :options="stateOpts"  @change="stateChange"/>
    </van-dropdown-menu>

    <div class="flow-list-page-container" v-if="loadingEnd">
      <div
        v-if="listType === 'RECYCLE' && recycleList && recycleList.length"
        class="list-container">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="fetchRecycleData">

          <div
            class="recycle-mix-form-item"
            v-for="(item, idx) in recycleList"
            :key="item.mixFormId">
            <div class="content-info">
              <div class="name">{{item.mixFormName}}</div>
              <div class="bottom">
              <span v-if="$store.getters.userListMap[item.userId]">
                {{$store.getters.userListMap[item.userId].nickname}}
              </span>
                <span>删除于{{actionFormatTime(item.updateTime)}}</span>
              </div>
            </div>
            <div class="handle">
              <el-button type="text" style="color: red;" @click.stop="onClickDelete(item, idx)">彻底删除</el-button>
              <el-button type="text" @click.stop="onClickRecover(item, idx)">恢复</el-button>
            </div>
          </div>
        </van-list>
      </div>

      <div
        v-else-if="listType !== 'RECYCLE' && mixFormList && mixFormList.length"
        class="list-container">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="fetchData">
          <div
            class="mix-form-item"
            v-for="(item, idx) in mixFormList"
            :key="item.mixFormId"
            @click="onClickMixForm(item)">
            <div class="top" v-if="item.top"></div>
            <div class="name">
              {{item.mixFormName}}
            </div>
            <div v-if="item.archived" class="archived-icon">
              <i class="iconfont icon-icon_submit"></i>
            </div>
          </div>
        </van-list>

      </div>

      <div v-else class="empty-data-container">
        <img src="../../../assets/images/empty.png" alt="">
        暂无项目
      </div>
    </div>

    <div
      class="add-button"
      @click="onClickAddMixForm">
       <i class="el-icon-plus"></i>
    </div>

    <add-mix-form-popup
      ref="addMixFormPopup"
      :stackList="stackList"
      :chargeUserConfig="chargeUserConfig"
      :participantConfig="participantConfig"
      :groupList="groupList"
      @createMixFormSuccess="createMixFormSuccess"
    ></add-mix-form-popup>
  </div>
</template>

<script>
  import {accurateFormatDate} from "../../../assets/js/Untis";
  import AddMixFormPopup from "../../component/mix_form/AddMixFormPopup";

  export default {

    beforeRouteLeave(to, form, next) {
      if (to.name !== "homeMixForm") {
        // 如果不是回退到项目首页，都放行。如果to是项目首页，那就意味着是点击返回键，需要拦截
        next(true)
        return
      }
      if (this.chargeUserConfig.showContact) {

        this.chargeUserConfig.showContact = false
        next(false)

      } else if (this.participantConfig.showContact) {

        this.participantConfig.showContact = false
        next(false)

      } else if (this.stackList.length) {

        const visibleInfo = this.stackList.pop()
        visibleInfo.visible = false
        next(false)
      } else {
        next(true)
      }
    },
    data() {
      return {
        title: '',
        stackList: [],
        mixFormList: [],
        recycleList: [], // 回收站列表
        groupList: [],
        loading: false,
        finished: false,
        loadingEnd: false,
        listType: 'ALL',
        filterInfo: {
          keyWords: '',
          status: '',
          archived: -1,
          groupIdList: []
        },
        pageConf: {
          currentPage: 0,
          pageSize: 20,
          totalPage: 1,
          totalCount: 1,
        },

        listTypeOpt: [
          { text: `全部${this.$store.getters.mix_form_name}`, value: 'ALL' },
          { text: `我创建的${this.$store.getters.mix_form_name}`, value: 'CREATE_BY_ME' },
          { text: `共享给我的${this.$store.getters.mix_form_name}`, value: 'SHARE_TO_ME' },
          { text: '回收站', value: 'RECYCLE' },
        ],
        tempListType: '',
        stateOpts: [
          { text: '全部', value: -1 },
          { text: '已归档', value: 1 },
          { text: '未归档', value: 0 }
        ],

        chargeUserConfig: {
          showContact: false
        },
        participantConfig: {
          showContact: false
        },
      }
    },
    components: {AddMixFormPopup},
    created() {
      this.title = this.$store.getters.mix_form_name
      this.tempListType = this.$route.query.type
      if (['ALL', 'CREATE_BY_ME', 'SHARE_TO_ME'].includes(this.$route.query.type)) {
        this.listType = this.$route.query.type
      } else {
        this.listType = 'GROUP'
        this.filterInfo.groupIdList.push(this.$route.query.type)
      }

      this.$store.dispatch('setPageTitle', this.title)
      this.fetchData()
      this.$store.dispatch('actionMixFormGroupList')
        .then(res => {
          this.groupList = res
          res.forEach(item => {
            this.listTypeOpt.push({
              text: item.groupName,
              value: item.groupId
            })
          })
        }).catch(console.error)
    },
    methods: {
      actionFormatTime(d) {
        return accurateFormatDate(d)
      },
      initPageConf() {
        this.loadingEnd = false
        this.finished = false
        this.pageConf.currentPage = 0
        this.pageConf.pageSize = 20
        this.pageConf.totalPage = 1
        this.pageConf.totalCount = 1
      },
      fetchData() {
        this.loading = true
        this.pageConf.currentPage++
        this.$store.dispatch('actionMixFormList', {
          listType: this.listType,
          ...this.filterInfo,
          ...this.pageConf
        }).then(res => {
          this.pageConf.currentPage = res.currentPage
          this.pageConf.totalPage = res.totalPage
          this.pageConf.totalCount = res.totalCount
          if (this.pageConf.currentPage === 1) {
            this.mixFormList.splice(0, this.mixFormList.length, ...res.dataList)
          } else {
            this.mixFormList.push(...res.dataList)
          }
          if (res.totalPage <= res.currentPage) {
            this.finished = true
          }
        }).catch(console.error)
          .finally(() => {
            this.loading = false
            this.loadingEnd = true
          })
      },
      fetchRecycleData() {
        this.loading = true
        this.pageConf.currentPage++
        this.$store.dispatch('actionMixFormRecycleList', {
          ...this.filterInfo,
          ...this.pageConf
        }).then(res => {
          this.pageConf.currentPage = res.currentPage
          this.pageConf.totalPage = res.totalPage
          this.pageConf.totalCount = res.totalCount
          if (this.pageConf.currentPage === 1) {
            this.recycleList.splice(0, this.recycleList.length, ...res.dataList)
          } else {
            this.recycleList.push(...res.dataList)
          }
        }).catch(console.error)
          .finally(() => {
            this.loading = false
            this.loadingEnd = true
          })
      },

      onSearch() {
        this.initPageConf()
        this.fetchData()
      },
      listTypeChange() {
        if (this.tempListType === 'RECYCLE') {
          this.listType = this.tempListType
          this.initPageConf()
          this.fetchRecycleData()
          return
        }

        if (['ALL', 'CREATE_BY_ME', 'SHARE_TO_ME'].includes(this.tempListType)) {
          this.listType = this.tempListType
          this.filterInfo.groupIdList.splice(0, this.filterInfo.groupIdList.length)
        } else {
          this.listType = 'GROUP'
          this.filterInfo.groupIdList.splice(0, this.filterInfo.groupIdList.length, this.tempListType)
        }
        this.onSearch()
      },
      stateChange() {
        this.onSearch()
      },

      onClickMixForm(item) {
        this.$router.push({
          name: 'mixFormNodeList',
          query: {
            mixFormId: item.mixFormId
          }
        })
      },

      onClickDelete(item, idx) {

        this.$dialog.confirm({
          title: '提示',
          message: '删除后数据将不可恢复，确定要删除吗?',
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$store.dispatch('actionMixFormRecycleDelete', {
            mixFormId: item.mixFormId
          }).then(res => {
            this.recycleList.splice(idx, 1)
            this.$toast.success('删除成功')
          }).catch(console.error)
        }).catch(() => {
        });
      },
      onClickRecover(item, idx) {

        this.$store.dispatch('actionMixFormRecycleRecover', {
          mixFormId: item.mixFormId
        }).then(res => {
          this.recycleList.splice(idx, 1)
          this.$toast.success('恢复成功')
        }).catch(console.error)
      },

      onClickAddMixForm() {
        if (this.$refs.addMixFormPopup) {
          this.$refs.addMixFormPopup.open({groupId: this.tempListType})
        }
      },
      createMixFormSuccess(mixFormId) {
        this.$router.push({
          name: 'mixFormNodeList',
          query: {
            mixFormId
          }
        })
      }
    }
  }
</script>

<style lang="less">

  .mix-form-list-page {
    height: calc(100% - env(safe-area-inset-bottom));
    background-color: #F6F6F6;
    box-sizing: border-box;
    position: relative;

    .van-dropdown-menu__bar {
      height: 40px;

      .van-dropdown-menu__title {
        font-size: 14px;
      }
    }

    .flow-list-page-container {
      height: calc(100% - 94px);
    }

    .list-container {
      height: 100%;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      padding: 10px;

      .mix-form-item {
        width: 100%;
        height: 50px;
        border: 1px solid #e6e6e6;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        position: relative;
        margin-bottom: 5px;
        background-color: #fff;

        .top {
          position: absolute;
          width: 14px;
          height: 14px;
          background: #4A66FA;
          font-size: 12px;
          color: #fff;
          padding: 2px;
          line-height: 100%;
          overflow: hidden;
          top: -1px;
          left: -1px;

          &:before {
            position: absolute;
            top: 1px;
            right: 0;
            content: "";
            width: 0;
            height: 0;
            border-top: 14px solid transparent;
            border-bottom: 14px solid transparent;
            border-right: 14px solid #fff;
          }
        }

        .name {
          width: calc(100% - 40px);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-wrap: break-word;
          font-size: 14px;
          color: #333;
        }

        .archived-icon {
          i {
            font-size: 34px;
            color: #05A971;
          }
        }
      }

      .recycle-mix-form-item {
        height: 50px;
        border: 1px solid #e6e6e6;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        position: relative;
        margin-bottom: 5px;
        background-color: #fff;

        >.content-info {
          width: 100%;

          .name {
            width: 100%;
            font-size: 14px;
            margin-bottom: 5px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-wrap: break-word;
          }

          .bottom {
            >span {
              color: #999;
              font-size: 12px;
            }
          }
        }

        .handle {
          display: flex;
          align-items: center;

          .el-button {
            font-size: 13px;
          }
        }
      }
    }

    .add-button {
      position: absolute;
      bottom: 40px;
      right: 20px;
      border-radius: 50%;
      width: 44px;
      height: 44px;
      padding: 0;
      background-color: #4A66FA;
      display: flex;
      justify-content: center;
      align-items: center;

      i {
        font-size: 20px;
        color: #ffffff;
      }
    }
  }
</style>